import { useEffect, useState } from "react";

//import material
import {
  Grid,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Card,
  Paper,
  CardHeader,
  Typography,
  CardContent,
  Button,
  IconButton,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogContentText,
  DialogActions,
  Divider,
  Stack,
  Box,
  useTheme,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import axios from "axios";

//import config from "../../../../config";

//project components

import SpecializationForm from "./SpecializationForm";
import useAxiosAuth from "../../../../../hooks/useAxiosAuth";
import NoDataFound from "../../../../../components/NoDataFound";

const Specialization = (props) => {
  //Constants
  const axiosAuth = useAxiosAuth();
  const pageSize = 100;
  const theme = useTheme();
  const { onSelectSpecialization, selectedSpecializationId } = props;
  console.log("onSelectSpecialization", onSelectSpecialization);
  //States
  const [candidateSpecialization, setCandidateSpecialization] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openAdd, setOpenAdd] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [showActions, setShowActions] = useState(false);
  const [successOpen, setSuccessOpen] = useState(false);
  const [successMsg, setSuccessMsg] = useState("Success");
  const [errorOpen, setErrorOpen] = useState(false);
  const [errorMsg, setErrorMsg] = useState("Error");
  const [selectedCandidateSpecialization, setSelectedCandidateSpecialization] =
    useState({
      id: 0,
      name: "",
    });

  const handleAdd = () => {
    setSelectedCandidateSpecialization({
      id: 0,
      name: "",
    });
    setOpenAdd(true);
  };
  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setSuccessOpen(false);
  };
  const handleErrorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setErrorOpen(false);
  };
  //Methods
  const getCandidateSpecialization = (skip) => {
    setLoading(true);
    axiosAuth
      .get("/api/CandidateSpecializationMasters/list?skip=0&take=" + pageSize)
      .then((response) => {
        setCandidateSpecialization(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };
  const handleDelete = () => {
    setLoading(true);
    axiosAuth
      .delete(
        "/api/CandidateSpecializationMasters/" +
          selectedCandidateSpecialization.id
      )
      .then((response) => {
        console.log("rrrrrrrrr", response);
        //onSave();
        getCandidateSpecialization();
        setOpenDelete(false);
      })
      .catch((error) => {
        console.log("eeeeeeeeee", error);
        setErrorOpen(true);
        setErrorMsg(
          "Unable to delete. This specialization is currently in use."
        );
        // console.log(error);
        setOpenDelete(false);
        setLoading(false);
      });
  };
  const handleSave = () => {
    // onSave();
    setOpenAdd(false);
  };
  const handleCancel = () => {
    setOpenAdd(false);
  };
  const handleCancelDelete = () => {
    setOpenDelete(false);
  };
  useEffect(() => {
    getCandidateSpecialization();
  }, []);

  return (
    <>
      <Grid container direction="row" spacing={2}>
        <Grid item xs={12} sm={12} md={12}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            spacing={2}
          >
            <Typography variant="h6">Specializations</Typography>

            <IconButton onClick={handleAdd}>
              <AddIcon />
            </IconButton>
          </Stack>
        </Grid>

        <Grid item xs={12} sm={12} md={12}>
          <Card
            variant="outlined"
            sx={{
              backgroundColor: theme.palette.grey[50],
              borderRadius: 2,
              padding: 1,
              minHeight: 100, // Ensure a minimum height for the loading state
            }}
          >
            {loading ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: 200,
                }}
              >
                <Stack
                  direction="column"
                  spacing={2}
                  justifyContent="center"
                  alignItems="center"
                >
                  <Typography variant="body1">
                    Loading specializations...
                  </Typography>
                  <CircularProgress />
                </Stack>
              </Box>
            ) : Array.isArray(candidateSpecialization) &&
              candidateSpecialization.length === 0 ? (
              <Grid item xs={12}>
                <NoDataFound />
              </Grid>
            ) : (
              candidateSpecialization.map((specialization, index) => {
                return (
                  <Card
                    key={specialization.id}
                    variant="outlined"
                    onMouseOver={() => setShowActions(true)}
                    onMouseOut={() => setShowActions(false)}
                    onClick={(e) => {
                      e.stopPropagation(); // Prevent event bubbling
                      onSelectSpecialization(specialization?.id);
                    }}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      borderRadius: 2,
                      cursor: "pointer",
                      backgroundColor:
                        selectedSpecializationId === specialization.id
                          ? theme.palette.primary.light
                          : theme.palette.background.paper,
                      "&:hover": {
                        backgroundColor:
                          selectedSpecializationId === specialization.id
                            ? theme.palette.primary.light // Keep same color if selected
                            : theme.palette.grey[100], // Hover effect only for non-selected
                      },
                      padding: 1,
                      marginBottom: 1,
                    }}
                  >
                    <CardContent sx={{ flex: 1, padding: 0 }}>
                      <Typography variant="subtitle1" noWrap>
                        {specialization.name}
                      </Typography>
                    </CardContent>
                    <IconButton
                      color="primary"
                      onClick={(e) => {
                        e.stopPropagation(); // Prevent triggering the card click
                        setSelectedCandidateSpecialization(specialization);
                        setOpenAdd(true);
                      }}
                    >
                      <EditIcon fontSize="small" />
                    </IconButton>
                    <IconButton
                      color="error"
                      onClick={(e) => {
                        e.stopPropagation(); // Prevent triggering the card click
                        setSelectedCandidateSpecialization(specialization);
                        setOpenDelete(true);
                      }}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Card>
                );
              })
            )}
          </Card>
        </Grid>
      </Grid>
      <Dialog open={openAdd} onClose={handleCancel} fullWidth>
        <DialogContent>
          <SpecializationForm
            onSave={handleSave}
            onCancel={handleCancel}
            selectedCandidateSpecialization={selectedCandidateSpecialization}
            getCandidateSpecialization={getCandidateSpecialization}
          />
        </DialogContent>
      </Dialog>
      <Dialog open={openDelete} onClose={handleCancelDelete} fullWidth>
        <DialogTitle>Delete Candidate Specialization</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete the candidate specialization of{" "}
            <span style={{ color: "#E90000" }}>
              {selectedCandidateSpecialization.name}
            </span>
            ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDelete} variant="contained">
            Yes
          </Button>
          <Button onClick={handleCancelDelete} variant="outlined">
            No
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={successOpen}
        autoHideDuration={6000}
        onClose={handleSuccessClose}
      >
        <Alert
          onClose={handleSuccessClose}
          severity="success"
          sx={{
            width: "100%",
            backgroundColor: "#009933",
            color: theme.palette.white.main,
          }}
          variant="filled"
        >
          {successMsg}
        </Alert>
      </Snackbar>
      <Snackbar
        open={errorOpen}
        autoHideDuration={6000}
        onClose={handleErrorClose}
      >
        <Alert
          onClose={handleErrorClose}
          severity="error"
          sx={{ width: "100%" }}
          variant="filled"
        >
          {errorMsg}
        </Alert>
      </Snackbar>
    </>
  );
};

export default Specialization;
